import { useRef } from "react";

interface RefObject {
  [key: string]: React.MutableRefObject<any>;
}

export const useActivityFormRefs = () => {
  const myRefs: RefObject = {};

  const propertyNames = [
    "expenses",
    "statesWithEmployees",
    "bookkeeper",
    "foreignAccounts",
    "foreignShareholdersAmount",
    "foreignShareholders",
    "internationalSubsidiaries",
    "internationalSubsidiariesAmount",
    "domesticSubsidiaries",
    "taxAssistance",
    "lastYearExpenses",
    "lastYearStatesWithEmployees",
    "lastYearForeignAccounts",
    "lastYearForeignShareholders",
    "completeBookkeepingLastYear",
    "lastYearInternationalSubsidiaries",
    "lastYearDomesticSubsidiaries",
  ];

  // Create a ref for each property name
  propertyNames.forEach((propertyName) => {
    myRefs[propertyName] = useRef<any>();
  });

  return { myRefs, propertyNames };
};
